<template>
    <div class="goods">
        <GoodsListItem v-for="item in goods" :goods-item="item"/>
    </div>
</template>

<script>
    import GoodsListItem from "./GoodsListItem";
    export default {
        name: "GoodsList",
        components:{
          GoodsListItem,
        },
        props:{
            goods:{
                type:Array,
                default(){
                    return[]
                }
            }
        },
    }
</script>

<style scoped>
.goods{
    display: flex;
    /*根据*/
    flex-wrap: wrap;
    /*中间均等分*/
    justify-content: space-around;
}
</style>